/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * FieldPay API
 * FieldPay API for managing organizations, opportunities, payouts and talent management
 * OpenAPI spec version: v1
 */

export type BatchProcessArea = typeof BatchProcessArea[keyof typeof BatchProcessArea];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BatchProcessArea = {
  Fsm: 'Fsm',
  PayoutRequest: 'PayoutRequest',
} as const;
